<template>
  <div>
    <v-skeleton-loader class="mx-auto" type="table-tbody" v-if="loading"> </v-skeleton-loader>

    <v-form v-if="!loading">
      <v-card class="pt-3">
        <v-card-title>
          <v-row>
            <v-col md="6"><h3 class="ml-2">{{isEditLabel ? $t('edit') : $t('add')}} {{$t('schedule_pattern')}}</h3></v-col>
            <v-col md="6">
              <v-btn icon class="float-right" @click="closeModal" v-if="showCloseModal">
                <v-icon>mdi-close</v-icon>
              </v-btn>
              <v-btn icon class="float-right" color="primary" @click="isEdit = !isEdit" v-if="disableInput">
                <v-icon>mdi-pencil</v-icon>
              </v-btn>
            </v-col>
          </v-row>
        </v-card-title>
        <v-card-text>
          <v-container>
            <v-row>
              <v-col md="6" sm="12">
                <v-text-field :rules="[validator.alfaNumberNotRequired]" :label="$t('schedule_name')" class="mt-2" v-model="dataItem.schedule_name" :disabled="disableInput"></v-text-field>
              </v-col>
              <v-col md="6" sm="12">
                <v-text-field :label="$t('total_days')" class="mt-2" disabled v-model="dataItem.patterns.length"></v-text-field>
              </v-col>
            </v-row>
            <v-row>
              <v-col md="4" sm="12">
                <v-text-field :rules="[validator.alfaNumberNotRequired]" :label="$t('tolerance')" type="number" class="mt-2" v-model="dataItem.tolerance" :disabled="disableInput"></v-text-field>
              </v-col>
              <v-col md="4" sm="12">
                <v-text-field :rules="[validator.alfaNumberNotRequired]" :label="$t('interval')" type="number" class="mt-2" v-model="dataItem.interval" :disabled="disableInput"></v-text-field>
              </v-col>
              <v-col md="4" sm="12">
                <!-- <v-text-field label="Timezone" type="number" class="mt-2" v-model="dataItem.timezone" :disabled="disableInput"></v-text-field> -->
                <v-select :label="$t('timezone')" :items="timezoneItems" v-model="dataItem.timezone" :disabled="disableInput"></v-select>
              </v-col>
            </v-row>
            <v-row>
              <v-col>
                <v-card>
                  <v-simple-table noboder>
                    <tbody v-for="(schedule, i) of dataItem.patterns" v-bind:key="i" fluid>
                      <tr v-if="i == 0" class="w-100">
                        <th v-show="!disableInput">{{$t('action_shift')}}</th>
                        <th v-show="disableInput"></th>
                        <th>{{$t('days')}}</th>
                        <th>{{$t('shift_code')}}</th>
                        <th>{{$t('default')}}</th>
                        <th>{{$t('shift_description')}}</th>
                        <th v-show="!disableInput">{{$t('action_day')}}</th>
                      </tr>

                      <tr v-for="(item, j) of schedule.shift_patterns" v-bind:key="j" class="ma-2">
                        <td>
                          <v-tooltip top v-if="j == 0">
                            <template v-slot:activator="{ on, attrs }">
                              <v-btn v-bind="attrs" v-on="on" icon color="primary" @click="addItem(i)" v-show="!disableInput">
                                <v-icon>mdi-plus-circle</v-icon>
                              </v-btn>
                            </template>
                            <span>{{$t('add_schedule')}}</span>
                          </v-tooltip>
                          <span v-else>
                            <v-tooltip top v-if=" j == schedule.shift_patterns.length - 1 && j > 0 ">
                              <template v-slot:activator="{ on, attrs }">
                                <v-btn v-bind="attrs" v-on="on" icon color="error" @click="removeItem(i, j)" v-show="!disableInput">
                                  <v-icon>mdi-close-circle</v-icon>
                                </v-btn>
                              </template>
                              <span>{{$t('remove_schedule')}}</span>
                            </v-tooltip>
                          </span>
                        </td>
                        <td>{{ j == 0 ? schedule.day : "" }}</td>
                        <td>
                          <v-autocomplete validate-on-blur label="" :items="masterShift" item-text="schedule_code" v-model="item.shiftMasterId" item-value="id" @change="changeShift(item, $event, `${i}-${j}`)" :disabled="disableInput"></v-autocomplete>
                        </td>
                        <td>
                          <v-radio-group v-model="schedule.default" :mandatory="false" @change="radioClick(dataItem)" :disabled="disableInput">
                            <v-radio label="" :value="j"></v-radio>
                          </v-radio-group>
                        </td>

                        <td class="pt-2">
                          <div v-if="masterLabel[i + '-' + j]">
                            <span class="pb-2"> {{$t('start')}} - {{$t('end')}} : {{ masterLabel[i + "-" + j].work_in | hour }} - {{ masterLabel[i + "-" + j].work_out | hour }} </span>
                            <br />
                            <span class="" v-if="masterLabel[i + '-' + j].break_in" > {{$t('break_time')}}: {{ masterLabel[i + "-" + j].break_in | hour }} - {{ masterLabel[i + "-" + j].break_out | hour }}</span>
                          </div>
                          <div v-else>
                            <span class="pb-2"> {{$t('start')}} - {{$t('end')}} : {{ item.work_in | hour }} - {{ item.work_out | hour }} </span>
                            <br />
                            <span class="" v-if="item.break_in"> {{$t('break_time')}}: {{ item.break_in | hour }} - {{ item.break_out | hour }}</span>
                          </div>
                        </td>
                        <td>
                          <span v-if="j == 0">
                            <v-tooltip top v-if="i == dataItem.patterns.length - 1">
                              <template v-slot:activator="{ on, attrs }">
                                <v-btn v-bind="attrs" v-on="on" icon color="primary" @click="addDay()" v-show="!disableInput">
                                  <v-icon>mdi-plus</v-icon>
                                </v-btn>
                              </template>
                              <span>{{$t('add_day')}}</span>
                            </v-tooltip>

                            <v-tooltip top v-if="i == dataItem.patterns.length - 1 && i > 0">
                              <template v-slot:activator="{ on, attrs }">
                                <v-btn v-bind="attrs" v-on="on" icon color="error" @click="removeDay(i)" v-show="!disableInput">
                                  <v-icon>mdi-delete</v-icon>
                                </v-btn>
                              </template>
                              <span>{{$t('remove_day')}}</span>
                            </v-tooltip>
                          </span>
                        </td>
                      </tr>

                    </tbody>
                  </v-simple-table>
                </v-card>
              </v-col>
            </v-row>
          </v-container>
        </v-card-text>
        <v-card-actions class="mx-6 pb-6">
          <v-spacer></v-spacer>
          <v-btn v-if="showCloseModal" color="primary" text @click="closeModal">{{$t('cancel')}}</v-btn>
          <div v-show="!disableInput">
            <v-btn v-if="!showCloseModal" color="primary" text @click="close">{{$t('cancel')}}</v-btn>
            <v-btn :loading="saveLoading" color="primary" dark @click="update(dataItem)" v-show="isDataExist && isEdit">{{$t('update')}}</v-btn>
            <v-btn :loading="saveLoading" color="primary" dark @click="insert(dataItem)" v-show="!isDataExist">{{$t('save')}}</v-btn>
          </div>
        </v-card-actions>
      </v-card>
    </v-form>
  </div>
</template>
<script>
export default {
  name: "PatternsSupervisor",
  props: ['pId', 'isEditLabel'],
  data() {
    return {
      showCloseModal: true,
      saveLoading: false,
      deleteLoading: false,
      deleteDialog: false,
      companyId: this.$store.state.company,
      groupId: this.$store.state.group_id,
      validator: this.$store.state.validator,
      baseUrl: this.$store.state.baseUrl,
      role: this.$store.state.role,
      loading: false,
      id: '',
      scheduleDescription: {
        schedule_name: '',
        tolerance: 0,
        interval: 60,
        timezone: 0,
        id: '',
      },

      scheduleType: [
        { text: this.$i18n.t('shift'), value: true },
        { text: this.$i18n.t('regular'), value: false },
      ],
      timezoneItems: [
        { text: 'WIB', value: 7 },
        { text: 'WITA', value: 8 },
        { text: 'WIT', value: 9 },
      ],
      isEdit: false,
      isDataExist: false,
      dataItem: {
        timezone: 0,
        scheduleName: '',
        days: 0,
        tolerance: 0,
        interval: 60,
        patterns: []
      },
      dataSchedule: null,
      masterShift: [],
      masterLabel: [],
    };
  },
  computed: {
    calcWorkTime(item) {
      return item
    },
    disableInput() {
      if (this.isDataExist) {
        if (this.isEdit) {
          return false
        } else {
          return true
        }
      } else {
        return false
      }
    }
  },
  methods: {
    radioClick(item) {
      this.dataItem = Object.assign({}, item)
    },
    addItem(i) {
      this.dataItem.patterns[i].shift_patterns.push({})
    },
    removeItem(i, j) {
      this.dataItem.patterns[i].shift_patterns.splice(j, 1)
    },
    addDay() {
      this.dataItem.patterns.push({ day: this.dataItem.patterns.length + 1, shift_patterns: [{}] })
    },
    removeDay(i) {
      this.dataItem.patterns.splice(i, 1)
    },
    changeShift(item, value, index) {
      const data = Object.assign({}, this.masterShift.find(e => { return e.id == value }))
      data.shiftMasterId = data.id
      delete data.id

      item = Object.assign({}, data)
      this.masterLabel[index] = Object.assign({}, item)
    },
    initDataMasterLabel(data) {
      data.patterns.map((schedule, i) => {
        schedule.shift_patterns.map((item, j) => {
          this.changeShift(item, item.shiftMasterId, `${i}-${j}`)
        })
      })
    },
    initScheduleDescription() {
      this.scheduleDescription = { schedule_name: '', tolerance: 0, timezone: 0, id: '', interval: 60 }
    },
    close() {
      this.isEdit = false
    },
    closeModal() {
      this.isEdit = false
      this.$emit('close', true)
    },
    saveScheduleDescription(temp) {
      this.id = temp.id
      this.scheduleDescription = {
        id: temp.id,
        schedule_name: temp.schedule_name,
        tolerance: temp.tolerance,
        timezone: temp.timezone,
        interval: temp.interval
      }
    },
    async getShiftMaster() {
      return await this.$store.dispatch('getScheduleShiftMasterByCompany', {companyId: this.companyId} )
    },
    async getShiftPattern() {
      let data = { patterns: [{ day: 1, shift_patterns: [{}] }] }
      if (this.pId) {
        const id = this.pId
        this.loading = true
        const result = await this.$store.dispatch('getSchedulePatternById', {id})
        this.loading = false
        if (result[0]) {
          this.saveScheduleDescription(result[0])
          if (result[0].shift_days) {
            if (result[0].shift_days.length > 0) {
              data.patterns = result[0].shift_days
              this.isDataExist = true
              this.isEdit = false
            } else {
              this.isDataExist = false
            }
          }
        }
      }
      return data
    },
    async insert(data) {
      const body = await this.mapingForSend(Object.assign({}, data))
      if (body != false) {
        this.saveLoading = true
        const result = await this.$store.dispatch('saveSchedulePattern', body)
        this.saveLoading = false
        if (result) {
          this.showMessage(this.$i18n.t('alert_save'), 'success')
        }
      }
    },
    async update(data) {
      const body = await this.mapingForSend(Object.assign({}, data))
      if (body != false) {
        this.saveLoading = true
        const result = await this.$store.dispatch('editSchedulePattern', body)
        this.saveLoading = false
        if (result) {
          this.showMessage(this.$i18n.t('alert_save'), 'success')
        }
      }
    },
    mapingData(items) {
      items.patterns.map((item) => {
        item.shift_patterns.map((schedule, j) => {
          if (schedule.default) {
            item.default = j
          }
        })
      })
      return Object.assign({}, items, this.scheduleDescription)
    },
    findDuplicate(data, key) {
      if (data) {
        const valueArr = data.map((item) => { return item[key] });
        const isDuplicate = valueArr.some((item, idx) => {
          return valueArr.indexOf(item) != idx
        });
        return isDuplicate
      } else {
        return false
      }
    },
    mapingForSend(data) {
      return new Promise((resolve) => {
        const validateDefault = { defaut: 0, pick: 0 }
        let validateShift = 0
        let isDuplicate = false

        data.patterns.map((item) => {
          const checkDuplicate = this.findDuplicate(item.shift_patterns, 'shiftMasterId')
          if (checkDuplicate) {
            isDuplicate = true
          }
          item.shift_master_id_array = []
          item.shift_patterns.map((schedule, i) => {
            item.shift_master_id_array[i] = {}
            item.shift_master_id_array[i].id = schedule.shiftMasterId
            item.shift_master_id_array[i].default = false
            typeof schedule.shiftMasterId == 'undefined' ? validateShift++ : null
          })

          if (item.default >= 0) {
            if (!item.shift_master_id_array[item.default]) {
              item.shift_master_id_array[item.default] = {}
            }

            item.shift_master_id_array[item.default].default = true
            validateDefault.pick++
          }
          validateDefault.defaut++
          // delete item.shift_patterns
        })

        if (this.pId) {
          data.id = this.pId
        }
        data.companyId = this.companyId
        data.pattern = data.patterns
        data.scheduleName = data.schedule_name

        if (validateDefault.pick === validateDefault.defaut) {
          if (validateShift < 1) {
            if (!isDuplicate) {
              delete data.patterns
              delete data.schedule_name
              return resolve(data)
            } else {
              this.showMessage(this.$i18n.t('multiple_shift_warning'), 'warning')
              return resolve(false)
            }
          } else {
            this.showMessage(this.$i18n.t('data_shift_warning'), 'warning')
            return resolve(false)
          }
        } else {
          this.showMessage(this.$i18n.t('default_shift_warning'), 'warning')
          return resolve(false)
        }
      })
    },
    showMessage(msg, type) {
      this.emitSaveStatus(msg, type)
    },
    emitSaveStatus(msg, type) {
      this.$emit('response', { msg, type })
    }
  },
  async created() {
    this.masterShift = await this.getShiftMaster()
    this.dataSchedule = await this.getShiftPattern()
    this.dataItem = this.mapingData(this.dataSchedule)
    this.initDataMasterLabel(this.dataItem)
  },
  async mounted() {
    if (this.pId) {
      this.dataSchedule = await this.getShiftPattern()
      this.dataItem = this.mapingData(this.dataSchedule)
      this.initDataMasterLabel(this.dataItem)
      this.showCloseModal = true
    }
  },
  watch: {
    async pId(id) {
      this.dataSchedule = await this.getShiftPattern()
      if (!id) {
        this.initScheduleDescription()
        this.isDataExist = false
      }
      this.dataItem = this.mapingData(this.dataSchedule)
      this.initDataMasterLabel(this.dataItem)
      this.showCloseModal = true
    }
  },

}
</script>
